var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaransaviRightDoubleWin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,29l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l0.6-1.7c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-0.6,1.7 C10.8,28.8,10.6,29,10.4,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7,24.9l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.1-3.4c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-1.1,3.4 C12.1,24.8,11.9,24.9,11.7,24.9z M13.7,19l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.1-3.4c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6l-1.1,3.4C14.1,18.9,13.9,19,13.7,19z M15.6,13.1l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6L16.3,9 c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-1.1,3.4C16,12.9,15.8,13.1,15.6,13.1z M17.6,7.1l-0.2,0C17.2,7,17,6.7,17.1,6.5 l0.9-2.8c0.1-0.3,0.4-0.4,0.6-0.3C18.9,3.4,19.1,3.7,19,4L18,6.8C18,7,17.8,7.1,17.6,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9,3.1l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6L19,0.8c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-0.6,1.7 C19.3,3,19.1,3.1,18.9,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9,30c-0.2,0-0.4-0.1-0.5-0.3l-0.9-2.8c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l0.9,2.8 c0.1,0.3-0.1,0.5-0.3,0.6L28.9,30z M27.1,24.4c-0.2,0-0.4-0.1-0.5-0.3l-1.2-3.7c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3 l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L27.1,24.4z M24.9,18c-0.2,0-0.4-0.1-0.5-0.3L23.3,14c-0.1-0.3,0.1-0.5,0.3-0.6 c0.3-0.1,0.5,0.1,0.6,0.3l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L24.9,18z M22.8,11.6c-0.2,0-0.4-0.1-0.5-0.3l-1.2-3.7 C21,7.3,21.2,7,21.4,6.9C21.7,6.9,22,7,22.1,7.2l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L22.8,11.6z M20.7,5.1c-0.2,0-0.4-0.1-0.5-0.3 L19,1.1c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l1.2,3.7c0.1,0.3-0.1,0.5-0.3,0.6L20.7,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.6c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7L28.8,0.6c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7 L12.3,15.5C12.2,15.6,12.1,15.6,12,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1,29c-0.1,0-0.2,0-0.3-0.1L11.7,15.5c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1l17.1,13.3 c0.2,0.2,0.2,0.5,0.1,0.7C29.3,28.9,29.2,29,29.1,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,29.7H0V0h30V29.7z M1,28.8h28V1H1V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26.3h-14V3.2h14V26.3z M13.3,25.4h12.3V4H13.3V25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2,26.5H2.6V3.1h4.5V26.5z M3.6,25.6h2.6V4.1H3.6V25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,29.4c-0.3,0-0.5-0.2-0.5-0.5v-28c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28C10.5,29.2,10.3,29.4,10,29.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 11.2,
    width: 3.5,
    height: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaransaviRightDoubleWin);
export default __webpack_public_path__ + "static/media/faransavi_right_double_win.821a4df3efe3a10d206e717a0ed05cf7.svg";
export { ForwardRef as ReactComponent };